import * as Sentry from '@sentry/browser';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  ProcessPaymentRequest,
  ProcessPaymentResponse,
} from '@cashier/cashier-api-model';
import { PaymentStates, PaymentTypes } from '@cashier/cashier-model';
import { PaymentStateChecker } from '@cashier/cashier-shared';

import { PaymentActionMapper } from '../utils/mapper';
import {
  processPaymentFailure,
  processPaymentStart,
  processPaymentSuccess,
} from './paymentProcessing.slice';

export const paymentProcessingEpic = (action$: any, state$: any, { Api }) =>
  action$.pipe(
    ofType(processPaymentStart.type),
    switchMap((action: { payload: ProcessPaymentRequest }) =>
      Api.processPayment(action.payload).pipe(
        // @TODO: for investigation purposes
        // map((data: ProcessPaymentResponse) =>
        //   processPaymentSuccess(
        //     PaymentActionMapper.toPaymentActionResult(data),
        //   ),
        // ),
        map((data: ProcessPaymentResponse) => {
          const currentTransactionState = (data.transactionState ||
            data.status) as PaymentStates;
          const paymentType = action.payload.paymentType as PaymentTypes;

          if (
            PaymentStateChecker.isSuccess(
              paymentType,
              currentTransactionState,
            ) ||
            PaymentStateChecker.isPending(paymentType, currentTransactionState)
          ) {
            return processPaymentSuccess(
              PaymentActionMapper.toPaymentActionResult(data),
            );
          }

          if ('resultAction' in data) {
            Sentry.captureException(
              new Error(
                '####Not successful status returned, but resultAction present. Status####: ',
              ),
              {
                extra: {
                  status: data.status || data.transactionState,
                },
              },
            );

            return processPaymentSuccess(
              PaymentActionMapper.toPaymentActionResult(data),
            );
          }

          Sentry.captureException(
            new Error('####Not successful status returned. Status####: '),
            {
              extra: {
                status: currentTransactionState,
              },
            },
          );

          return processPaymentFailure(
            PaymentActionMapper.toPaymentActionError(data),
          );
        }),
        catchError((err) =>
          of(
            processPaymentFailure(
              PaymentActionMapper.toPaymentActionError(err),
            ),
          ),
        ),
      ),
    ),
  );

export const processPayment = (data: ProcessPaymentRequest) => ({
  type: processPaymentStart.type,
  payload: data,
});
